import React from 'react';
import cx from 'clsx';

import loadable from '@loadable/component';
import * as themeStyles from '../../assets/theme.module.scss';
import * as moduleStyles from './Nav.module.scss';
import { COMPLETE_URL_KEY } from '../../utils/specMapping';

const MdToHtml = loadable(() => import('../MdToHtml'));
const ProductSpecDetailTable = loadable(() => import('../ProductSpecDetailTable'));

export default class Navs extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: props.tabs[0].key,
        };
    }

    onSelect = (activeKey) => {
        this.setState({ activeKey });
    }

    render() {
        const { activeKey } = this.state;
        const { tabs } = this.props;

        return (
            <>
                <ul className={cx(themeStyles.nav, themeStyles.navTabs)} role="tablist">
                    {tabs.map(({ name, key, content }) => {
                        if (content) {
                            return (
                                <li className={themeStyles.navItem} key={key} aria-controls={`content-${key}`} role="tab" onClick={() => this.onSelect(key)}>
                                    <button className={cx(themeStyles.navLink, themeStyles.bgWhite, moduleStyles.tab, { [themeStyles.active]: activeKey === key, [moduleStyles.tabActive]: activeKey === key })} eventKey={key}>{name}</button>
                                </li>
                            );
                        }
                    })}
                </ul>

                <div className={themeStyles.pt6} role="region">
                    {tabs.map(({
                        content, key, type, specPdfLink,
                    }) => {
                        if (content) {
                            return (
                                <div key={key} role="tabpanel" id={`content-${key}`} className={cx({ [moduleStyles.hide]: key !== activeKey })}>
                                    {type === 'md'
                                        ? <MdToHtml data={content} />
                                        : null}
                                    {type === 'table'
                                        ? <ProductSpecDetailTable headers={content.headers} rows={content.rows} hasLink={!!content.rows[0][COMPLETE_URL_KEY]} specPdfLink={specPdfLink} />
                                        : null}
                                </div>
                            );
                        }
                        return null;
                    })}
                </div>
            </>
        );
    }
}
